import { getDeviceSystemVersion, getAppVersion, getAppName } from 'DeviceUtils';

class AbstractAnalyticsService {
    constructor(analyticsModule) {
        this.userId = null;
        this.userLangugage = null;
        this.analyticsModule = analyticsModule;
    }

    /**
     * @param {string|number} userId
     */
    setUserId(userId) {
        this.analyticsModule.setUserId(userId.toString());
        this.userId = userId;
    }

    /**
     * @param {string} language
     */
    setUserLanguage(language) {
        this.userLangugage = language;
    }

    /**
     * @param {string} event
     * @param {*} params
     */
    logEvent(event, params) {
        if (!this.userId) {
            console.log('User id is not defined for analytics');
        }
        try {
            this.analyticsModule.logEvent(event, {
                // OS Version
                osv: getDeviceSystemVersion(),
                // Session ID
                cid: undefined,
                // App ID
                aid: undefined,
                // App version
                av: getAppVersion(),
                // App Name
                an: getAppName(),
                // User ID
                uid: this.userId,
                // User Language
                ul: this.userLangugage,
                ...params
            });
        } catch (error) {
            console.log(
                `Could not send ${event} with params: ${JSON.stringify(
                    params,
                    null,
                    2
                )} \n ${error}`
            );
        }
    }
}
export default AbstractAnalyticsService;
